// the sticky add to cart quantity is not related (huge minimog bug) to the main atc , this function does so

const bundleSection = document.querySelector('#bundle_section');

const waitForStickyLoaded = (callBack) =>{
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {    
          callBack
          observer.unobserve(entry.target);
        }
      });
    },
    { once: true }
  );
  
  let elementToObserve = document.querySelector(".prod__sticky-atc");
  observer.observe(elementToObserve);
}

const updateBothQty = () => {
  const productInfoSection = document.querySelector('.sf-prod__info');
  const stickySection = document.querySelector('.prod__sticky-atc');
  
  const topMoreLessBtns = productInfoSection.querySelectorAll('.quantity-input__button')
  const stickyMoreLessBtns = stickySection.querySelectorAll('.quantity-input__button')
 
  let qtyTopElement = productInfoSection.querySelector(".quantity-input__element");
  let qtyStickyElement = stickySection.querySelector(".quantity-input__element");

  topMoreLessBtns.forEach(btn => {
    btn.addEventListener("click", () =>{
      setTimeout(()=>{
        qtyStickyElement.value = qtyTopElement.value
      },200)
        
    })
  })
  stickyMoreLessBtns.forEach(btn => {
    btn.addEventListener("click", () =>{
      setTimeout(()=>{        
          qtyTopElement.value = qtyStickyElement.value  
          if( bundleSection ) {
            const stickyBtn = stickySection.querySelector('button[type="submit"][name="add"].add-to-cart');
            stickyBtn.removeAttribute('disabled'); 
          }
      },200)
        
    })
  })
}
  
waitForStickyLoaded(updateBothQty())  
 
 